import { AppNS } from 'app';
import { UserData } from 'app/types';

export const PROFILE_TABS = [
  {
    index: 0,
    name: 'General Info',
    slug: 'main',
    disabled: false,
    visible: true,
  },
  {
    index: 1,
    name: 'Disciplines',
    slug: 'disciplines',
    disabled: false,
    visible: true,
  },
  {
    index: 2,
    name: 'Employment',
    slug: 'employment',
    disabled: false,
    visible: true,
  },
  {
    index: 3,
    name: 'Metrics',
    slug: 'metrics',
    disabled: false,
    visible: true,
  },
];

export const PERFORMANCE_TABS = [
  {
    index: 0,
    name: 'Dashboard',
    slug: 'dashboard',
    disabled: false,
    visible: true,
  },
  {
    index: 1,
    name: 'Quarterly QA/QC',
    slug: 'qa-report',
    disabled: false,
    visible: true,
  },
  {
    index: 2,
    name: 'CTP Records',
    slug: 'ctp_records',
    disabled: false,
    visible: false,
  },
];

export const INSPECTOR_STATES: { id: AppNS.InspectorProfileState; name: string }[] = [
  { id: 'draft', name: 'Draft' },
  { id: 'pending', name: 'Pending' },
  { id: 'active', name: 'Active' },
  { id: 'suspended', name: 'Suspended' },
  { id: 'deactivated', name: 'Deactivated' },
  { id: 'resigned', name: 'Resigned' },
];

export const getStateNameById = (id: string): string => {
  return INSPECTOR_STATES.find((item) => item.id === id)?.name || '-';
};

export const isInspectorEditable = (currentUser: UserData | null, inspectorId: string): boolean => {
  if (!currentUser || !inspectorId) {
    return false;
  }
  return currentUser.id === inspectorId && currentUser?.inspectorProfile?.state !== 'deactivated';
};
